
import React from 'react';
import { useToast } from "../../hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "../../components/ui/toast";

export function Toaster() {
  console.log('Toaster component rendering');
  try {
    const { toasts } = useToast();
    console.log('Toasts loaded:', toasts?.length || 0);

    return (
      <ToastProvider>
        {toasts?.map(function ({ id, title, description, action, ...props }) {
          return (
            <Toast key={id} {...props}>
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
              {action}
              <ToastClose />
            </Toast>
          );
        })}
        <ToastViewport />
      </ToastProvider>
    );
  } catch (error) {
    console.error('Error rendering Toaster:', error);
    return (
      <div className="hidden">Toaster error: {String(error)}</div>
    );
  }
}
